import React, {useEffect} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Row, Col } from "atomize";
import styled from "styled-components";
import {apiGet} from "../../../Api";
import {baseUrl} from "../../../Constants/constants";


const Wrapper = styled(Row)`
  margin-top: 2rem;
`;

const Description = styled(Col)`
  
  max-height: 400px;
  overflow-y: scroll;
  > div {
    padding-right: 2rem;
    @media (max-width: 766px) {
      padding-right: 0;
      margin-top: 2rem;
    }
  }
  p {
    margin-bottom: 1rem;
    color: ${theme.colors.grayDark};	
    font-family: Inter;	
    font-size: 16px;	
    line-height: 28px;
  }
`;

const Image = styled(Col)`
  position: relative;
  img {
    width: 100%;
    box-shadow: 0 0 1px 0 rgba(10,22,70,0.06), 0 6px 6px -1px rgba(10,22,70,0.1);
  }
`;

function OutcomesItem(props) {
  const [data, setData] = React.useState({});
  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/learning_outcome/${props.outcome.id}?include=field_image&jsonapi_include=1`);
      setData(result.data.data);
    }

    fetchData();
  }, []);

  return (
    <Wrapper
      size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
    >
      <Image>
        { data.field_image &&
          <img alt={props.outcome.field_image.meta.alt } src={ baseUrl + data.field_image.uri.url } />
        }
      </Image>
      <Description
        size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
      >
        <div dangerouslySetInnerHTML={{ __html: props.outcome.body.value }} />
      </Description>
    </Wrapper>
  )
}

export default OutcomesItem
